import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import { EvaluationPttService, RequestVendorService } from "src/services";
import PropTypes from "prop-types";

import AddBoxIcon from "@mui/icons-material/AddBox";
import CheckIcon from "@mui/icons-material/Check";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import InfoIcon from '@mui/icons-material/Info';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Autocomplete,
  createFilterOptions,
  FormControl,
} from "@mui/material";
import { Button } from "@material-ui/core";
import PageLoading from "../PageLoading/PageLoading.Component";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {},
  tableHead: {
    color: "rgb(0, 53, 138) !important",
    fontWeight: "bold !important",
    backgroundColor: "rgb(138, 227, 255) !important",
  },
  textarea: {
    resize: "both",
  },
  tableContainer: {
    overflowY: "auto",
  },
  table: {
    height: "100%",
    overflowY: "scroll",
  },
  tableRow: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  btnSearch: {
    color: "#fff",
    backgroundColor: "#FE744C ",
    marginLeft: theme.spacing(2),
    padding: theme.spacing(0, 2),
    "&:hover": {
      color: "#FE744C",
      backgroundColor: "#fddad0 ",
    },
    "&:disabled": {
      color: "rgba(0, 0, 0, 0.26)",
      backgroundColor: "rgba(0, 0, 0, 0.12) ",
    },

  },
  btnAdd: {
    color: "#fff",
    border: 0,
    backgroundColor: "#FE744C ",
    "&:hover": {
      color: "#FE744C",
      backgroundColor: "#fddad0 ",
    },
  },
  warningSearchVendor: {
    color: "#72828A",
    marginLeft: theme.spacing(2),
  },
  iconSearchButton: {
    "&:hover": {
      backgroundColor: "#ffcc80 !important",
    },
  },
}));

const columns = [
  { id: "vendorId", label: "", minWidth: 50 },
  {
    id: "vatRegistrationNo",
    label: "เลขที่ประจำตัวผู้เสียภาษี/E-mail",
    minWidth: 100,
    align: "left",
  },
  { id: "vendorCode", label: "รหัสผู้ค้า", minWidth: 100, align: "left" },
  {
    id: "vendorNameMain",
    label: "ชื่อผู้ค้า",
    minWidth: 220,
    align: "left",
  },
];
const inputGrid = {
  VendorCode: "",
  VendorName: "",
  VatRegistrationNo: "",
  lang: "th",
};

function PopupSearchVendor(props) {
  const [open, setOpen] = useState(false);
  const { onClose, selectedValue, isViewMode } = props;
  const [vendors, setVendors] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [onLoading, setOnLoading] = useState(false);
  const [vendorCode, setVendorCode] = useState("");
  const [vendorName, setVendorName] = useState("");
  const handleChangeVendorName = (event) => {
    setVendorName(event.target.textContent);
  };
  const [vendorVat, setVendorVat] = useState("");
  const [ddlVendorName, setddlVendorName] = useState([]);
  const classes = useStyles();
  const { t } = useTranslation();
  
  const columns = [
    { id: "vendorId", label: "", minWidth: 50 },
    { id: "vatRegistrationNo", label: <>{t("EvaluationPtt.taxNumber")}</>, minWidth: 100, align: "left", },
    { id: "email", label: <>{"E-Mail"}</>, minWidth: 100, align: "left", },
    { id: "vendorCode", label: <>{t("EvaluationPtt.vendorCode")}</>, minWidth: 100, align: "left" },
    { id: "vendorNameMain", label: <>{t("EvaluationPtt.vendorName")}</>, minWidth: 220, align: "left", },
  ];

  useEffect(() => {
    RequestVendorService.SearchVendor(inputGrid).then((resp) => {
      setVendors(resp);
    });
  }, []);

  const editIcon = (data) => (
    <IconButton onClick={() => handleListItemClick(data)}>
      <CheckIcon fontSize="small" />
    </IconButton>
  );

  const SearchGrid = () => {
    inputGrid.VendorCode = vendorCode;
    inputGrid.VendorName = vendorName;
    inputGrid.VatRegistrationNo = vendorVat;
    inputGrid.lang = "th";
    RequestVendorService.SearchVendor(inputGrid).then((resp) => {
      setVendors(resp);
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
    setOnLoading(true);
    inputGrid.VendorCode = "";
    inputGrid.VendorName = "";
    inputGrid.VatRegistrationNo = "";
    inputGrid.lang = "th";
    RequestVendorService.SearchVendor(inputGrid)
      .then((resp) => {
        setVendors(resp);
      })
      .then(() => setOnLoading(false));
    EvaluationPttService.ddlVendorName().then((resp) => {
      setddlVendorName(resp);
    });
    setVendorVat('');
    setVendorName('');
  };

  const handleClose = (value) => {
    setOpen(false);
    onClose(value);
  };

  useEffect(() => {
    if (vendors.length > 0 && selectedValue) {
      onClose(
        vendors.find((vendor) => vendor.vatRegistrationNo === selectedValue)
      );
    }
  }, [selectedValue, vendors]);

  const handleAddVendor = () => {
    setOpen(false);
    window.open("/RequestVendor/Create", "_blank");
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleListItemClick = (value) => {
    onClose(value);
    setOpen(false);
  };

  return (
    <div>
      <PageLoading open={onLoading} />
      <Button
        disabled={isViewMode}
        className={classes.btnSearch}
        onClick={handleClickOpen}
      >
        <SearchIcon fontSize="medium" />
        {t("VendorSelf.searchVendor")}
      </Button>
      <span className={classes.warningSearchVendor}>
        {t("VendorSelf.pleaseSelectVendor")} <span style={{ color: "red" }}>*</span>
      </span>
      <div>
        <Dialog
          fullWidth
          maxWidth="lg"
          open={open}
          onClose={handleClose}
          aria-labelledby="draggable-dialog-title"
        >
          <DialogTitle
            style={{ cursor: "move", fontWeight: "bold" }}
            id="draggable-dialog-title"
          >
            {t("VendorSelf.searchVendor")}
          </DialogTitle>
          <DialogContent>
            <Grid
              container
              rowSpacing={2}
              spacing={1}
              columns={16}
              direction="row"
              alignContent="left"
              justifyContent="left"
            >
              <Grid item xs={5}>
                <FormControl
                  sx={{ width: "100%" }}
                  style={{ paddingTop: "10px" }}
                >
                  <TextField
                    size="small"
                    onChange={(e) => {
                      setVendorVat(e.target.value);
                      // if (/^[0-9]*$/.test(e.target.value)) {
                      //   setVendorVat(e.target.value.replace(/[^0-9\\.]+/g, ''));
                      // }
                    }}
                    value={vendorVat}
                    style={{ backgroundColor: "white" }}
                    fullWidth
                    id="outlined-search"
                    label={t("EvaluationPtt.taxNumber")}
                    type="search"
                    inputProps={{ className: classes.textarea, autoComplete: 'off' }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={2}>
                <FormControl
                  sx={{ width: "100%" }}
                  style={{ paddingTop: "10px" }}
                >
                  <TextField
                    size="small"
                    onChange={(e) => setVendorCode(e.target.value)}
                    style={{ backgroundColor: "white" }}
                    fullWidth
                    id="outlined-search"
                    label="Vendor code"
                    type="search"
                    inputProps={{ className: classes.textarea, autoComplete: 'off' }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={8}>
                <FormControl sx={{ width: "100%" }}>
                  <Autocomplete
                    id="ddlVendorName"
                    size="small"
                    options={ddlVendorName}
                    filterOptions={createFilterOptions({
                      limit: 20,
                    })}
                    value={
                      ddlVendorName.filter((x) => x.label === vendorName)
                        .length > 0
                        ? ddlVendorName.filter((x) => x.label === vendorName)[0]
                        : vendorName
                    }
                    renderInput={(params) => (
                      <TextField {...params} label={t("EvaluationPtt.vendorName")} onChange={({ target }) => setVendorName(target.value)} variant="outlined" fullWidth/>
                    )}
                    onChange={(event) => {
                      handleChangeVendorName(event);
                    }}
                    onKeyDown={e => {
                      console.log('e.code',e.code);
                      if (e.code === 'Enter') {
                        SearchGrid();
                      }
                    }}
                    style={{ backgroundColor: "white", paddingTop: "10px" }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={1}>
                <FormControl style={{ paddingTop: "10px" }}>
                  <IconButton
                    className={classes.iconSearchButton}
                    sx={{ color: "#f57c00", backgroundColor: "#f57c00" }}
                    onClick={() => SearchGrid()}
                  >
                    <SearchRoundedIcon sx={{ color: "white" }} />
                  </IconButton>
                </FormControl>
              </Grid>
              <Grid item xs={16}>
                <Paper sx={{ width: "100%", overflow: "hidden" }}>
                  <TableContainer className={classes.tableContainer}>
                    <Table
                      stickyHeader
                      aria-label="sticky table"
                      className={classes.table}
                    >
                      <TableHead>
                        <TableRow>
                          {columns.map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              className={classes.tableHead}
                              style={{
                                minWidth: column.minWidth,
                              }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {vendors.length > 0 ? (
                          vendors
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row, i) => {
                              return (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={i}
                                >
                                  {columns.map((column) => {
                                    const value = row[column.id];
                                    return (
                                      <TableCell
                                        key={column.id}
                                        align={column.align}
                                        className={classes.tableRow}
                                        onClick={() => handleListItemClick(row)}
                                      >
                                        {column.id === "vendorId"
                                          ? editIcon(row)
                                          : value}
                                      </TableCell>
                                    );
                                  })}
                                </TableRow>
                              );
                            })
                        ) : (
                          <TableRow>
                            <TableCell colSpan={7}>
                              <Grid
                                container
                                style={{ fontWeight: "bold" }}
                                direction="row"
                                justifyContent="center"
                              >
                                ไม่พบข้อมูลผู้ค้า
                              </Grid>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 100]}
                    component="div"
                    count={vendors.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Paper>
              </Grid>
              {vendors.length && (
                <>
                  <Grid item xs={16} container justifyContent="center">
                    <Button
                      variant="outlined"
                      // color="warning"
                      className={classes.btnAdd}
                      startIcon={<AddBoxIcon />}
                      onClick={handleAddVendor}
                    >
                      {t("VendorSelf.addVendor")}
                    </Button>
                  </Grid>
                  <Grid item xs={16} container justifyContent="center" style={{ paddingTop: '0px' }}>
                    <InfoIcon sx={{ color: '#8ae3ff' }} /> {t("VendorSelf.addVendorWarning")}
                  </Grid>
                </>
              )}
            </Grid>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
}

PopupSearchVendor.propTypes = {
  onClose: PropTypes.func.isRequired,
  selectedValue: PropTypes.string,
  isViewMode: PropTypes.bool,
};
export default PopupSearchVendor;
